<template>
  <b-modal id="barcode"
           hide-footer
           title="Moja karta"
           lazy
           centered
  >
    <div class="text-center">
      <h1 v-if="barcodeFormat === 'EAN13' && cardNumber.length === 12">
        {{ cardNumber }}
      </h1>
      <div v-else-if="barcodeFormat === 'QR'">
        <qrcode :value="cardNumber" :options="{ width: 200 }" />
        <p style="font-size:20px">{{ cardNumber }}</p>
      </div>
      <div v-else>
        <vue-barcode :value="cardNumber" :format="barcodeFormat">
          <h1>{{ cardNumber }}</h1>
        </vue-barcode>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import VueBarcode from 'vue-barcode'
  import {mapState} from 'vuex'

  export default {
    name: "Barcode",
    components: {
      VueBarcode
    },
    computed: mapState({
      cardNumber: state => state.auth.user.card_number,
      barcodeFormat: state => state.settings.barcodeFormat
    })
  }
</script>

<style>
  .text-center {
    text-align: center;
  }

  .vue-barcode-element {
    width: 100%;
  }
</style>
